import { InMemoryCache } from '@apollo/client';
import typePolicies from './cacheTypePolicies';
import possibleTypes from './possibleTypes.json';
const generateApolloCache = () => new InMemoryCache({
    possibleTypes,
    typePolicies
});
export default generateApolloCache;
